module.exports = __webpack_public_path__ + "img/role_sad.d1ea8153.png";